import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableService } from '../../../../shared/services/datatable.service';
import * as moment from 'moment';
import { FormBuilder } from '@angular/forms';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { HttpParams } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import { ModalUploadNfComponent } from './modal-upload-nf/modal-upload-nf.component';
import { ListaPedidoAprovadoService } from './lista-pedido-aprovado.service';
import { IMyDpOptions } from 'mydatepicker';
import * as XLSX from 'xlsx';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData, DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';

registerLocaleData(localePtBr);
@Component({
  selector: 'ngx-lista-pedido-aprovado',
  templateUrl: './lista-pedido-aprovado.component.html',
  styleUrls: ['./lista-pedido-aprovado.component.scss']
})
export class ListaPedidoAprovadoComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public formPedidoAprovado = null; 
  public tableLimit = 10;

  public showDetailTable = false;
  public rowDataDetail = [];
  public selected = [];
  public customLogin = null;
  /** Auxiliar de máscara CPF/CNPJ para o filtro cnpjComprador. */
  public cnpjCompradorMaskAux = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",

  };

  constructor(
    private router: Router,
    private datatableService: DatatableService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private paginationService: SpringDatatablePaginationService,
    private dialogService: NbDialogService,
    private service: ListaPedidoAprovadoService,
    private datePipe: DatePipe,
    private dateUtil: DateUtilService,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private notificationsService: NotificationsService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.formPedidoAprovado = this.formBuilder.group({
      cnpj: [null],
      dataPagamento: [null],
      cnpjComprador: [null],
      valorPedido: [null],
      nomeFantasiaComprador: [null],
      dataPedido: [null]
    });
  }


  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
    this.buscaPedido();
  }

  buscaPedido(data?: any, page?: string) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit));

    if (page) {
      params = params.append('page', page);
    }

    if (data && data.cnpjComprador != null && String(data.cnpjComprador).trim() !== '') {
      params = params.append('cnpjComprador', this.normalizarCnpjCpfParaBackend(data.cnpjComprador));
    }

    if (data && data.nomeFantasiaComprador != null) {
      params = params.append('nomeFantasiaComprador', data.nomeFantasiaComprador);
    }

    if (data && data.valorPedido != null) {
      params = params.append('valorPedido', data.valorPedido);
    }

    if (data && data.dataPedido != null) {
      params = params.append('dataPedido', this.dateUtil.datepickerTransformDate(data.dataPedido, 'YYYY-MM-DD'));
    }

    this.service.industryOnlineSaleList(params, (response => {
     
      this.rowDataDetail = response.content
      this.paginationService.setInfo(response);

    }), (error) => this.notificationsService.error(error.message));

  }

  buscaDetalhePedido(data: any) {
    let params = new HttpParams();
    params = params.append('codigoAutorizacao', data.transacaoId);

    let dataAutorizacao: Date = this.dateUtil.parseDate(data.dataAprovacao, 'YYYY-MM-DD');
    params = params.append('dataAutorizacao', '' + this.dateUtil.formatDate(dataAutorizacao, 'YYYY-MM-DD'));

    this.service.industryOnlineSaleDetail(params, (response => {


      this.rowDataDetail = response.map(data => {
        return {
          valorParcelaBruto: data.valorParcelaBruto,
          valorParcelaLiquido: data.valorLiquido,
          parcela: data.numeroParcela,
          dataPagamento: data.dataPagamento,
        };
      });


    }), (error) => this.notificationsService.error(error.message));

  }

  getDateTimestamp(data) {
    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }

  showCardVisualiza(data) {
    const cnpjFavNorm = this.normalizarCnpjCpfParaBackend(data.favorecido.cpfCnpj);
    let cnpjEmpresaVendedora: any = this.encriptyService.encriptyBySecretKey('' + cnpjFavNorm);
    let idComprador: any = this.encriptyService.encriptyBySecretKey('' + data.idComprador);


    let params = {
      'cnpj': cnpjEmpresaVendedora,
      'idComprador': idComprador
    }


    this.router.navigate(['/pages/compra-online/visualiza-dados-nf'], { relativeTo: this.activatedRoute, queryParams: params });

  }

  showCardModalUpload(data: any) {
    this.dialogService.open(ModalUploadNfComponent, {
      context: {
        id: data.id
      },
    })

  } 

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45 )) {

      this.formPedidoAprovado.controls['valorPedido'].setValue(null);
      this.notificationsService.error('Não é permitido números negativos!');

    }
    return true;

  }

  selectedRow(data: any) {
    this.datatablePagination.rowData.forEach(row => {
      if (row.id !== data.id && row['selected'] === true) {
        row['selected'] = false;
      }
    });

    if (data.selected) {
      this.showDetailTable = true;
      this.buscaDetalhePedido(data);
    } else {
      this.showDetailTable = false;
    }


  }

  exportarXlsx(dataSearch: any) {
    let params = new HttpParams();
    params = params.append('allElements', 'true');

    if (dataSearch && dataSearch.cnpjComprador != null && String(dataSearch.cnpjComprador).trim() !== '') {
      params = params.append('cnpjComprador', this.normalizarCnpjCpfParaBackend(dataSearch.cnpjComprador));
    }

    if (dataSearch && dataSearch.nomeFantasiaComprador != null) {
      params = params.append('nomeFantasiaComprador', dataSearch.nomeFantasiaComprador);
    }

    if (dataSearch && dataSearch.valorPedido != null) {
      params = params.append('valorPedido', dataSearch.valorPedido);
    }

    if (dataSearch && dataSearch.dataPedido != null) {
      params = params.append('dataPedido', this.dateUtil.datepickerTransformDate(dataSearch.dataPedido, 'YYYY-MM-DD'));
    }
    this.service.industryOnlineSaleList(params, (response => {

      let rowData = response.content.map(data => {
        return {
          id: data.id,
          transacaoId: data.transacaoId,
          nomeFantasiaComprador: data.nomeFantasiaComprador,
          valor: data.valor,
          dataAprovacao: moment(data.dataAprovacao).format('DD/MM/YYYY'),
          dataPedido: moment(data.dataPedido).format('DD/MM/YYYY'),
          selected: false,

        };
      });


      this.prepareXlsx(rowData);

    }), (error) => this.notificationsService.error(error.message));


  }


  prepareXlsx(data: Array<any>) {
    if (data != null && data.length > 0) {
      let rowData = Object.assign([], data);
      let listRows = [['Data Pedido', 'Valor Pedido', 'Comprador', 'Data Aprovação']];

      rowData.forEach(data => {
        let dataPedido = data.dataPedido != null ? this.datePipe.transform(data.dataPedido, 'dd/MM/yyyy') : '';
        let valor = data.valor != null ? data.valor : '';
        let nomeFantasiaComprador = data.nomeFantasiaComprador != null ? data.nomeFantasiaComprador : '';
        let dataAprovacao = data.dataAprovacao != null ? this.datePipe.transform(data.dataAprovacao, 'dd/MM/yyyy') : '';

        let line = [dataPedido, valor, nomeFantasiaComprador, dataAprovacao];
        listRows.push(line);
      });
      let ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(listRows);
      let wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Pedido Aprovados');

      /* save to file */
      XLSX.writeFile(wb, 'Pedido Aprovados.xlsx');
    }
  }

  previousPage() {
    this.location.back();
  }

  limpaForm() {

    this.cnpjCompradorMaskAux = null;
    this.formPedidoAprovado = this.formBuilder.group({
      cnpj: [null],
      dataPagamento: [null],
      cnpjComprador: [null],
      valorPedido: [null],
      nomeFantasiaComprador: [null],
      dataPedido: [null]
    });

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfCnpjMask(): string {
    const ctrl = this.formPedidoAprovado && this.formPedidoAprovado.get('cnpjComprador');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCompradorMaskAux != null && String(this.cnpjCompradorMaskAux).trim() !== ''
        ? this.cnpjCompradorMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
